const types = {
  SET_SD_TICKETS: "SET_SD_TICKETS",
  SET_SD_TICKET: "SET_SD_TICKET",
  UPDATE_SD_TICKET: "UPDATE_SD_TICKET",
  ADD_SD_COMMENT: "ADD_SD_COMMENT",
  SET_SD_LOADING: "SET_SD_LOADING",
};

export default types;
